const Info = ({msg, setMsg}) => {
  const handleClose = ev => {
    setMsg(false);
  }
  if (msg===false) return null;
  return(
    <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            {msg[1]?<h2>{msg[0]}</h2>:<p style={{whiteSpace: 'pre-wrap'}}>{msg[0]}</p>}
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
    {msg[1] &&
          <div className="modal-body" style={{whiteSpace: 'pre-wrap'}}>
            {msg[1]}
          </div>
    }
        </div>
      </div>
    </div>
  )
}
export default Info;